export default __webpack_public_path__ + "static/media/Obavestenje o obradi podataka o licnosti.068ce599.pdf";